<template>
  <van-popup v-if="firstLoad" v-model="popShow" :closeOnClickOverlay="false">
    <div class="dialog">
      <img class="top_pic" :src="topPic" />
      <div
        class="inner_box"
        :style="{
          paddingTop: topPic ? '0' : '0.24rem',
          borderRadius: topPic ? '0 0 0.24rem 0.24rem' : '0.24rem'
        }"
      >
        <slot></slot>
        <div v-if="title" class="title">{{ title }}</div>
        <div v-if="content" class="content">{{ content }}</div>
        <slot name="footer"></slot>
        <div v-if="showBtn" class="btn_box">
          <div v-if="cancelText" class="btn cancel" @click="onCancel">
            {{ cancelText }}
          </div>
          <div class="btn confirm" @click="onConfirm">
            {{ confirmText ? confirmText : $t('common.confirm') }}
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'CommonDialog',
  props: {
    value: Boolean,
    topPic: String,
    title: String,
    content: String,
    confirmText: String,
    cancelText: String,
    showBtn: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      firstLoad: false, // 解决首次加载报错问题
      popShow: false
    }
  },
  watch: {
    value(val) {
      this.popShow = val
      if (val) {
        this.firstLoad = true
      }
    },
    popShow(val) {
      this.$emit('input', val)
    }
  },
  methods: {
    onConfirm() {
      this.$emit('confirm')
    },
    onCancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>
.dialog {
  width: calc(100% - 0.48rem);
  box-sizing: border-box;
}

.top_pic {
  width: 100%;
  display: block;
  position: relative;
  top: 0.03rem; /* 偏移一点解决两个元素之间的缝隙问题 */
  mix-blend-mode: multiply;
  image-rendering: -webkit-optimize-contrast; /* Chrome, Safari */
  image-rendering: optimize-contrast; /* CSS3 Proposed */
}

.inner_box {
  padding: 0.24rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
}

.title {
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.18rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.26rem;
  margin-bottom: 0.12rem;
}

.content {
  color: #5b5b5b;
  font-family: 'PingFang SC';
  font-size: 0.16rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.24rem;
}

.btn_box {
  width: 100%;
  margin-top: 0.24rem;
  display: flex;
}

.btn {
  display: flex;
  width: 100%;
  padding: 0.13rem 0.24rem;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  border-radius: 0.08rem;
  border: 0.01rem solid #3fbb70;
  color: #3fbb70;
  text-align: center;
  font-family: 'PingFang SC';
  font-size: 0.16rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.24rem;
}

.btn.cancel {
  margin-inline-end: 0.12rem;
}

.btn.confirm {
  background: #3fbb70;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/CommonDialog.vue